/* eslint-disable no-redeclare */
import { DomainSessionId, ProductType } from '@hc-frontend/core-types';
import { z } from 'zod';

export const BuyersRequest = z.object({
  domain_session_id: DomainSessionId,
  product: ProductType,
  smid: z.string(),
});

export type BuyersRequest = z.infer<typeof BuyersRequest>;

export const BuyersResponse = z.object({
  body: z.object({
    buyers: z.array(
      z.object({
        partner_id: z.number(),
        buyer_id: z.string(),
      }),
    ),
  }),
});

export type BuyersResponse = z.infer<typeof BuyersResponse>;
